module.exports = __webpack_public_path__ + "static/media/Drone_surveillance.3daaf555.png";